import _CircularProgress from "@mui/material/CircularProgress";
import _Divider from "@mui/material/Divider";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _Skeleton from "@mui/material/Skeleton";
import _Button2 from "@mui/material/Button";
import React from 'react';
import { useTranslation } from 'react-i18next';
import emptyStateIllustration from '../../../assets/images/find-illus.svg';
import { useChallenge, useSubGroupColors } from '../../../hooks';
import PodiumCard, { podiumOrder, podiumRanksConfig } from '../../event/leaderboard/podium-card';
import { UserAvatar } from '../../user';
import FakeEmployees from '../individual-leaderboard/fake-employees';
import LeaderboardIndividualHeader from '../individual-leaderboard/header';
import LeaderboardIndividualItem from '../individual-leaderboard/item';
import RankCard from '../individual-leaderboard/rank-card';
function IndividualLeaderboard({
  Button: _Button,
  FakeItemsCard,
  isFree,
  isHolding,
  disableLeaderboardRestriction,
  event,
  freeOfferEmployeesLeaderboardsMaxRowsCount,
  page,
  leaderboard,
  count,
  sites,
  teams,
  userChallenge,
  loading,
  rankField,
  rankFieldLabel,
  setPage
}) {
  const {
    t
  } = useTranslation();
  const {
    getProgressValueWithUnit,
    getRankFieldValueWithUnit
  } = useChallenge();
  const {
    teamsColors
  } = useSubGroupColors({
    teams
  });
  function getValueLabel(progressValue) {
    return rankField && rankField !== 'progress_value' ? getRankFieldValueWithUnit(rankField, progressValue) : getProgressValueWithUnit(event.challengeTemplate?.type || 'bttf', progressValue);
  }
  const showSite = !isHolding && !!sites && sites.length > 0;
  const showTeam = !isHolding && !!teams && teams.length > 0;
  const Button = _Button || _Button2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !leaderboard || leaderboard.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, page === 1 && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-end",
    display: "flex",
    gap: 3,
    width: "100%"
  }, podiumOrder.map(({
    itemIndex,
    rank
  }) => {
    const item = leaderboard?.[itemIndex];
    const podiumLoading = !leaderboard;
    return /*#__PURE__*/React.createElement(PodiumCard, {
      avatar: podiumLoading || item ? /*#__PURE__*/React.createElement(UserAvatar, {
        size: podiumRanksConfig[rank].avatarSize,
        user: item ? {
          profilePicture: item.profilePicture,
          username: item.username
        } : undefined
      }) : null,
      key: rank,
      rank: rank
    }, /*#__PURE__*/React.createElement(_Typography, {
      noWrap: true,
      fontSize: "0.9375rem",
      fontWeight: 600,
      title: item?.username || ''
    }, item ? item.username : podiumLoading ? /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: "100%"
    }) : '–'), /*#__PURE__*/React.createElement(_Typography, {
      fontSize: "1.125rem",
      fontWeight: 800
    }, item ? getValueLabel(item.progressValue) : podiumLoading ? /*#__PURE__*/React.createElement(_Skeleton, {
      variant: "text",
      width: 100
    }) : '–'));
  })), /*#__PURE__*/React.createElement(RankCard, {
    challengeTemplate: event.challengeTemplate,
    numberOfParticipants: count,
    progress: userChallenge,
    rankField: rankField
  }), /*#__PURE__*/React.createElement(_Box, {
    border: "1px solid #dde0e7",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  }, /*#__PURE__*/React.createElement(LeaderboardIndividualHeader, {
    columnLabel: rankFieldLabel,
    event: event,
    showSite: showSite,
    showTeam: showTeam
  }), leaderboard ? /*#__PURE__*/React.createElement(React.Fragment, null, leaderboard.map(({
    id,
    leaderboardIndex,
    rank,
    progressValue,
    profilePicture,
    username,
    subGroups
  }, index) => {
    const site = subGroups?.find(({
      type
    }) => type === 'companySite');
    const team = subGroups?.find(({
      type
    }) => type === 'companyTeam');
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: id
    }, /*#__PURE__*/React.createElement(_Divider, {
      sx: {
        borderColor: '#dde0e7'
      }
    }), /*#__PURE__*/React.createElement(LeaderboardIndividualItem, {
      challengeType: event.challengeTemplate?.type,
      item: {
        user: id ? {
          id,
          profilePicture,
          username: username || ''
        } : null,
        leaderboardIndex,
        rank,
        progressValue
      },
      prevItemRank: index > 0 ? leaderboard[index - 1].rank : null,
      showSite: showSite,
      showTeam: showTeam,
      site: site?.title,
      team: team ? {
        color: teamsColors?.[team.id] || '#333',
        title: team.title
      } : undefined,
      valueLabel: rankField && rankField !== 'progress_value' ? getRankFieldValueWithUnit(rankField, progressValue) : undefined
    }));
  }), isFree && !disableLeaderboardRestriction && count && count > freeOfferEmployeesLeaderboardsMaxRowsCount && /*#__PURE__*/React.createElement(FakeEmployees, {
    event: event,
    FakeItemsCard: FakeItemsCard,
    freeOfferEmployeesLeaderboardsMaxRowsCount: freeOfferEmployeesLeaderboardsMaxRowsCount
  })) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(_Divider, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/React.createElement(LeaderboardIndividualItem, {
    challengeType: event.challengeTemplate?.type,
    prevItemRank: null,
    showSite: showSite,
    showTeam: showTeam
  }))))) : /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 5
  }, /*#__PURE__*/React.createElement("img", {
    height: 64,
    src: emptyStateIllustration
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, t('commons.challenges.leaderboard.empty_state_title_company')), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    variant: "body2"
  }, t('commons.challenges.leaderboard.empty_state_description')))), (!isFree || disableLeaderboardRestriction) && leaderboard && count && count > leaderboard.length ? /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: loading,
    endIcon: loading && /*#__PURE__*/React.createElement(_CircularProgress, {
      color: "inherit",
      size: 16,
      thickness: 4
    }),
    onClick: () => setPage(page + 1),
    size: "small",
    variant: "outlined"
  }, t('commons.actions.see_more'))) : /*#__PURE__*/React.createElement(React.Fragment, null));
}
export default IndividualLeaderboard;